import React from 'react';

/**
 * 목록을 한 쪽씩 넘긴다.
 *
 * 좁은 화면에서는 '더 보기' 하나로 이어 붙인다. 걸어 다니며 보는 사람에게
 * 쪽 번호를 손가락으로 찍게 하면 잘못 누르기 쉽고, 앞뒤로 오가는 일도 드물다.
 * 넓은 화면에서는 쪽 번호를 낸다 -- 스무 쪽짜리를 '더 보기' 로만 내려가게 하면
 * 뒤쪽에 있는 것을 볼 방법이 없다.
 */
/**
 * onChange(nextPage, append)
 *
 * append 는 좁은 화면의 '더 보기' 에서만 참이다. 부르는 쪽이 이어 붙일지
 * 갈아치울지 알아야 하는데, 그건 어느 단추를 눌렀는지에 달렸다.
 */
const Pagination = ({ page, total, limit, onChange, loading }) => {
  const lastPage = Math.max(1, Math.ceil(total / limit));
  if (total <= limit) return null;

  // 지금 쪽을 가운데 두고 앞뒤로 두 쪽씩. 쪽이 많아도 줄이 넘치지 않는다.
  const from = Math.max(1, Math.min(page - 2, lastPage - 4));
  const pages = [];
  for (let p = from; p <= Math.min(lastPage, from + 4); p++) pages.push(p);

  return (
    <>
      <div className="d-md-none text-center mt-3">
        {page < lastPage && (
          <button
            className="btn btn-white border rounded-pill px-4"
            onClick={() => onChange(page + 1, true)}
            disabled={loading}
          >
            {loading ? '불러오는 중…' : `더 보기 (${total - page * limit}건 남음)`}
          </button>
        )}
      </div>

      <div className="d-none d-md-flex justify-content-center align-items-center gap-1 mt-3">
        <button
          className="btn btn-sm btn-white border"
          onClick={() => onChange(page - 1)}
          disabled={page <= 1 || loading}
        >
          <i className="bi bi-chevron-left"></i>
        </button>
        {pages.map((p) => (
          <button
            key={p}
            className={`btn btn-sm ${p === page ? 'btn-primary' : 'btn-white border'}`}
            style={{ minWidth: '36px' }}
            onClick={() => onChange(p)}
            disabled={loading}
          >
            {p}
          </button>
        ))}
        <button
          className="btn btn-sm btn-white border"
          onClick={() => onChange(page + 1)}
          disabled={page >= lastPage || loading}
        >
          <i className="bi bi-chevron-right"></i>
        </button>
      </div>
    </>
  );
};

export default Pagination;
